import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>
      <p>Welcome to Diyatharippu International Optometric. These Terms and Conditions govern your use of our website and the purchase and sale of service from our platform. By accessing and using our website, you agree to comply with these terms. Please read them carefully before proceeding with any transactions.</p>
      
      <div className="terms-section">
        <h2>Use of the Website</h2>
        <ul>
          <li>You must be at least 16 years old to use our website or make purchases.</li>
          <li>You are responsible for maintaining the confidentiality of your account information, including your username and password.</li>
          <li>You agree to provide accurate and current information during the registration and checkout process.</li>
          <li>You may not use our website for any unlawful or unauthorized purposes.</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>Product Information and Pricing</h2>
        <ul>
          <li>We strive to provide accurate service descriptions, images, and pricing information. However, we do not guarantee the accuracy or completeness of such information.</li>
          <li>Prices are subject to change without notice. Any promotions or discounts are valid for a limited time and may be subject to additional terms and conditions.</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>Orders and Payments</h2>
        <ul>
          <li>By placing an order on our website, you are making an offer to purchase the selected services.</li>
          <li>We reserve the right to refuse or cancel any order for any reason, including but not limited to service availability, errors in pricing, or suspected fraudulent activity.</li>
          <li>You agree to provide valid and up-to-date payment information and authorize us to charge the total order amount, including applicable taxes and shipping fees, to your chosen payment method.</li>
          <li>We use trusted third-party payment processors to handle your payment information securely.</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>Shipping and Delivery</h2>
        <p>We will make reasonable efforts to ensure timely shipping and delivery of your orders. However, shipping and delivery times are estimates and may vary.</p>
      </div>

      <div className="terms-section">
        <h2>Returns and Refunds</h2>
        <p>Our <a href="/refundpolicy">Refund Policy</a> governs the process and conditions for returning products and seeking refunds.</p>
      </div>

      <div className="terms-section">
        <h2>Intellectual Property</h2>
        <p>All content on our website, including text, images, and logos, is protected by intellectual property rights and is the property of Diyatharippu International Optometric Conference or its licensors.</p>
      </div>

      <div className="terms-section">
        <h2>Limitation of Liability</h2>
        <p>We are not liable for any direct, indirect, incidental, special, or consequential damages arising out of your use of our website or products.</p>
      </div>

      <div className="terms-section">
        <h2>Amendments and Termination</h2>
        <p>We reserve the right to modify, update, or terminate these Terms and Conditions at any time without prior notice.</p>
      </div>

      <div className="terms-section terms-contact-section">
        <h2>Contact Us</h2>
        <p>If you have any questions about these Terms and Conditions, please <a href="/contactus">contact us.</a> </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
